<template>
  <v-col
    v-if="isECOMemberPassEnabled"
    cols="auto"
  >
    <v-row>
      <v-col>
        <v-tooltip
          v-if="currentUser.isAdmin"
          bottom
        >
          <template
            #activator="{ on, attrs }"
          >
            <v-btn
              v-bind="attrs"
              icon
              v-on="on"
              @click="_ => onShowIssueEcoMemberPassDialog()"
            >
              <v-icon>
                mdi-ticket-account
              </v-icon>
            </v-btn>
          </template>
          <span>Issue ECO Member Card</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <IssueEcoMemberCardDialog
      v-model="showIssueEcoMemberPassDialog"
    />
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { alertHandler } from '@/alertHandler'

import IssueEcoMemberCardDialog from '@/components/Dialogs/Party/IssueEcoMemberCardDialog'

import { INTEGRATION_NAMESPACE } from '@/store/integrations'
import { PARTY_NAMESPACE } from '@/store/party'

export default {
  name: 'EcoMemberPass',

  components: {
    IssueEcoMemberCardDialog,
  },

  setup () {
    return {
      ...alertHandler(),
    }
  },

  data () {
    return {
      showIssueEcoMemberPassDialog: false,
    }
  },

  computed: {
    ...mapGetters([
      'currentUser',
    ]),

    ...mapGetters(PARTY_NAMESPACE, [
      'peParty',
    ]),

    ...mapGetters(INTEGRATION_NAMESPACE, [
      'isECOMemberPassEnabled',
    ]),
  },

  created () {
    if (this.currentUser.isAdmin) {
      this.ecoMemberPassEnabled().
        finally(_ => {
          if (this.peParty.id) this.fetchECOMemberPasses({ partyId: this.peParty.id })
        })
    }
  },

  methods: {
    onShowIssueEcoMemberPassDialog () {
      this.showIssueEcoMemberPassDialog = true
    },

    ...mapActions(INTEGRATION_NAMESPACE, [
      'ecoMemberPassEnabled',
      'fetchECOMemberPasses',
    ]),
  },
}
</script>
